"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniqueVoucherIds = exports.orderNumber = exports.base35 = exports.randomPassword = exports.randomInt = exports.cuid = void 0;
const collections_1 = require("../collections");
const misc_1 = require("../lib/misc");
var cuid2_1 = require("@paralleldrive/cuid2");
Object.defineProperty(exports, "cuid", { enumerable: true, get: function () { return cuid2_1.createId; } });
function randomInt(min = 10, maxExclusive, random = Math.random.bind(Math)) {
    let currentMin = min;
    let currentMax = maxExclusive;
    if (maxExclusive === undefined) {
        currentMin = Math.pow(10, min);
        currentMax = min * 10;
    }
    const diff = (currentMax !== null && currentMax !== void 0 ? currentMax : 0) - currentMin;
    return Math.floor(random() * diff + currentMin);
}
exports.randomInt = randomInt;
function randomPassword(length = 32) {
    const chars = (0, collections_1.range)(33, 127).map((i) => String.fromCodePoint(i));
    return Array.from({ length }, () => (0, collections_1.randomPick)(chars)).join('');
}
exports.randomPassword = randomPassword;
exports.base35 = (() => {
    const chars = '0123456789ABCDEFGHIJKLMNPQRSTUVWXYZ';
    return {
        toString(number) {
            let result = '';
            let remainder = number;
            while (remainder > 0) {
                result = chars[remainder % 35] + result;
                remainder = Math.floor(remainder / 35);
            }
            return result || '0';
        },
        parse(string) {
            let result = 0;
            for (let i = 0; i < string.length; i++) {
                const digitValue = chars.indexOf(string[i]);
                result = result * 35 + digitValue;
            }
            return result;
        },
    };
})();
function orderNumber(randomSize = 2) {
    const now = new Date();
    const diff = now.getTime() - new Date(2021, 0, 0).getTime();
    const d = Math.floor(diff / (1000 * 60 * 60 * 24));
    const s = 13600 +
        now.getUTCHours() * 3600 +
        now.getUTCMinutes() * 60 +
        now.getUTCSeconds();
    const ds = (now.getMilliseconds() / 1000).toString().slice(2, 3);
    const rd = Math.pow(10, (randomSize - 1));
    const r = randomInt(rd, rd * 10).toString();
    const dgt = [...`${d}${s}${r}`];
    dgt.splice(1, 0, ds);
    return dgt.join('');
}
exports.orderNumber = orderNumber;
function voucherId() {
    return Number.parseInt(orderNumber(3)).toString(36).toUpperCase();
}
function uniqueVoucherIds(quantity) {
    return __awaiter(this, void 0, void 0, function* () {
        const ids = new Set();
        while (ids.size < quantity) {
            if (ids.size > 0 && !(ids.size % 800)) {
                yield (0, misc_1.delay)(() => null, 100);
            }
            ids.add(voucherId());
        }
        return [...ids];
    });
}
exports.uniqueVoucherIds = uniqueVoucherIds;
